export const HU = {
  preparing_zip: "Zip előkészítése…",
  compressing: "Tömörítés…",
  info_icon: "Ha egyszer befejezettként van megjelölve, nem csatlakozhatnak vagy adhatók hozzá további tagok, és minden csevegőcsoport deaktiválódik. Kérjük, vegye figyelembe, hogy a projekt, az összes csevegőcsoporttal és adattal együtt, deaktivált állapotban marad elérhető.",
  mark_is_done: "Biztosan be szeretné jelölni a projektet befejezettként? Ha egyszer megjelölt, nem csatlakozhatnak vagy adhatók hozzá további tagok, és minden csevegőcsoport deaktiválódik. Kérjük, vegye figyelembe, hogy a projekt, az összes csevegőcsoporttal és adattal együtt, deaktivált állapotban marad elérhető.",
  mark_not_done: "Biztosan újra meg szeretné nyitni a projektet? Ha egyszer nyitottként van megjelölve, további tagok csatlakozhatnak vagy hozzáadhatók, és minden csevegőcsoport újraaktiválódik.",
  mark_as_completed: "Projekt befejezettként jelölése",
  room_completed: "Projekt befejezve",
  room_members: "Projekt tagjai",
  deactivated_rooms: "Deaktivált projektek",
  deactivated_chats: "Deaktivált csevegések",
  completed_rooms: "Befejezett projektek",
  request_to_join_a_room: 'Kérelem a projekthez való csatlakozáshoz',
  wants_to_rejoin_room: 'Username újra csatlakozni szeretne a Roomname projekthez.',
  invited_you_to_join_room: 'Username meghívott, hogy csatlakozz a Roomname projekthez.',
  restart: "Újraindítás",
  update_text: "Új frissítés érhető el. Kattintson az újraindításra a frissítés telepítéséhez.",
  update_availble: "Frissítés elérhető",
  Loading: "Betöltés...",
  logout: "Kijelentkezés",
  back: 'Vissza',
  company_list: "Céglista",
  followers: "Követők",
  followings: "Követések",
  article: "Cikk",
  companies: "Cégek",
  one_to_one_chat: " Egy-egy csevegés",
  profile: "Profil",
  company: "Cég",
  company_selection: "Cég kiválasztása",
  home: "Kezdőlap",
  contact: "Kapcsolat ",
  add_company: "Cég hozzáadása ",
  add_project: "Projekt hozzáadása ",
  capacities: "Kapacitások ",
  work_area: "Munkaterület",
  company_services: "Cég szolgáltatásai",
  website: "Weboldal",
  search_contacts: "Kapcsolatok keresése",
  add_or_join_a_company: "Cég hozzáadása vagy csatlakozás",
  follow: "Követés",
  following: "Követés",
  like: "Tetszik",
  company_contacts: "Cég kapcsolata",
  leave_the_company: "Cég elhagyása",
  news: "Hírek",
  earlier: "Korábban",
  action: "Művelet",
  another_action: "Másik művelet",
  something_else: "Valami más",
  search: "Keresés",
  search_rooms: "Projektek keresése",
  search_articles: "Cikkek keresése",
  contacts: "Kapcsolatok",
  suggestions: "Javaslatok",
  project_list: "Projektlista",
  search_results: "Keresési eredmények",
  add_or_join_project: "Projekt hozzáadása vagy csatlakozás",
  details: "Részletek",
  your_position_within_company:
    "Kérjük, válassza ki a pozícióját a cégen belül.",
  close_modal: "Bezárás",
  map: "Térkép",
  or: "Vagy",
  name: "Név*",
  street: "Utca*",
  house_number: "Házszám",
  postal_code: "Irányítószám",
  city: "Város*",
  opened_by: "Megnyitotta:",
  project_No: "Projektszám: ",
  building_type: "Épület típusa*",
  building_types: "Épület típusa",
  add_join: "Hozzáadás/Csatlakozás",
  mandatory_fiels: "*kötelező mezők",
  invalid_fiels: "Ez a mező kötelező",
  add_or_join_company: "Cég hozzáadása vagy csatlakozás",
  name_of_the_company: "Cég neve",
  edit_company_details: "Cég adatainak szerkesztése",
  branch_of_the_building_industry: "Építőipar ága",
  corporate_form: "Jogi forma",
  position_within_company: "Pozíció a cégen belül",
  request_confirmation: "Függőben lévő projekt kérések",
  company_e_mail: "Cég e-mailje",
  type_of_filter: "Írjon a szűréshez...",
  setting: "Beállítás",
  dashboard: "Irányítópult",
  settings: "Beállítások",
  views: "Megtekintések",
  times_seen: "alkalommal megtekintve",
  see_more: "...több",
  see_less: "...kevesebb",
  in_search: "keresésben",
  reset_password: "Jelszó visszaállítása",
  submit: "Küldés",
  password: "Jelszó",
  email: "E-mail",
  confirm_password: "Jelszó megerősítése",
  reset_email: "E-mail visszaállítása",
  update: "Frissítés",
  new_email: "Új e-mail",
  kjuup_message: "Kjuup Üzenet",
  delete_profile: "Profil törlése?",
  my_position: "Pozícióm:",
  add: "hozzáadás",
  owner_company_admin: "Cég adminisztrátor :",
  owner_company_admin_new: "Cég adminisztrátor",
  mutual_contact: "közös kapcsolat",
  mutual_contacts: "közös kapcsolatok",
  co_owner: "Társtulajdonos",
  managing_director: "Ügyvezető igazgató",
  associate: "Társ",
  secretary: "Titkár",
  employee: "Alkalmazott",
  project_manage: "Projektmenedzser",
  auto_chat_translation: "Automatikus csevegés fordítása",
  translate_room_group_names: "Csevegőcsoport-nevek fordítása",
  translate_room_group_names_info: "Ha be van kapcsolva, a csevegőcsoport-nevek automatikusan lefordulnak a felület nyelvére.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Ha engedélyezve van, az alkalmazás megnyitásakor alapértelmezetten az E-Mail fül nyílik meg az Üzenetek helyett.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Nyelv",
  english: "Angol",
  german: "Német",
  french: "Francia",
  italian: "Olasz",
  change_language: "Nyelv váltása",
  my_companies: "Cégeim",
  employees: "Alkalmazottak",
  invite_with_a: "Meghívás a Kjuup-ba",
  add_member: "Tag hozzáadása",
  add_user: "Felhasználó hozzáadása",
  send_location: "Helyszín küldése",
  assign_admin_rights: "Adminisztrátor jog beállítása",
  deactivate_company: "Cég deaktiválása",
  remove_employees: "Alkalmazottak eltávolítása",
  remove_members: "Tagok eltávolítása",
  no_user_found: "Nem található felhasználó!",
  approve: "Jóváhagyás!",
  deselect_all: "Összes kijelölés megszüntetése",
  select_all: "Összes kijelölése",
  translation_on_building_projects: "Fordítás projektekben",
  reported_capacities: "Jelentett szolgáltatások",
  up_to_50m_exact: "Akár 50m pontos",
  company_details_service: "Cég szolgáltatásai",
  company_contact: "Cég kapcsolata",
  invite_with_link: "Meghívás a Kjuup-ba",
  share_link: "Link megosztása",
  share_company_link: "Link megosztása",
  qr_code: "QR kód",
  copy_link: "Link másolása",
  cancel_link: "Link törlése",
  who_has_confirmed_services: "Ki erősítette meg a szolgáltatásait?",
  projectss: "Projektek",
  add_services: "Szolgáltatások hozzáadása",
  services: "Szolgáltatások",
  save_text: "Mentés",
  share_on: "Megosztás:",
  articlen: "Cikk",
  invite_user_to_confirm_service:
    "Hívja meg a felhasználókat, hogy erősítsék meg a szolgáltatásokat a cégnek.",
  link_copied: "Link másolva!",
  email_copied: "E-mail másolva!",
  personal_article: "Személyes cikk",
  company_article: "Cég cikke",
  characters_remaining: "Hátralévő karakterek",
  optional_information: "Opcionális információ",
  project: "Projekt",
  projects: "Projektek...",
  abort: "Elvetés",
  preview: "Előnézet",
  post: "Közzététel",
  of: "a",
  remove: "Eltávolítás",
  free_capacity: "Állásportál",
  current_status_overview: "Jelenlegi állapot áttekintése",
  report_capacities: "Szolgáltatások jelentése",
  report_text: "Jelentés",
  search_capacities: "Vállalkozók keresése",
  add_project_user: "Projekt felhasználó hozzáadása",
  media: "Média",
  links: "Linkek",
  docs: "Dokumentumok",
  featured_products: "Kiemelt termékek...",
  title: "Cím",
  text: "Szöveg",
  feed_details: "Hírfolyam részletei",
  add_employee: "Alkalmazott hozzáadása",
  latest: "Legújabb",
  my_projects: "Projektjeim",
  cancel: "Mégse",
  continue: "Folytatás",
  role_in_the_building_industry: "Szerep az építőiparban",
  als: "mint",
  join: "csatlakozás",
  find: "Keresés",
  request_to_join_a_company: "Kérelem a céghez való csatlakozáshoz",
  wants_to_join_the_company: "csatlakozni szeretne a céghez",
  filter_by: "Szűrés",
  ok: "Ok",
  close: "Bezárás",
  weekly_statistics: "Heti statisztikák",
  is_following_you: "követi Önt.",
  as: "mint",
  has_joined_the: "csatlakozott a céghez",
  has_looked_at_your_profile: "megnézte a profilját.",
  time: "Idő",
  in_searches_in_past_week: "keresésekben a múlt héten.",
  has_liked_your_article: "tetszett neki a cikke.",
  has_published_a_new_article: "új cikket publikált.",
  you: "Ön",
  all_views: "Összes megtekintés",
  all_profile_views: "Összes profil megtekintés",
  mutual_company: "közös cég",
  artical_text: "Cikk írása...",
  you_have_appeared: "Megjelent",
  your_request_at_the_company: "Kérése a cégnél",
  times_you_have_appeared_in_searches: "alkalommal jelent meg keresésekben",
  appear_more_often_in_searches: "Gyakrabban jelenjen meg keresésekben",
  you_have_been_found: "Megtalálták",
  improve_profile: "Profil javítása",
  choose_existing_contact_for_single_chat:
    "Válasszon meglévő kapcsolatot egy-egy csevegéshez:",
  in_order_to_add_new_contacts:
    "Új kapcsolatok hozzáadásához kérjük, keressen új kapcsolatokat a profil oldalon.",
  times_in_searches_in_the_last_week:
    "alkalommal keresésekben a múlt héten. Frissítse a profilját és adjon hozzá további részleteket, hogy könnyebben megtalálható legyen.",
  has_been_confirmed: "megerősítve lett.",
  have_joined_the: "csatlakoztak a  ",
  building_project: " építési projekthez.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Válassza ki a céget, amelyet képviselni fog. Ez megjelenik a többi résztvevőnek.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Válassza ki a céget, amelyet képviselni fog. Ez megjelenik a többi résztvevőnek.",
  select_internal_section: "Kérjük, válassza ki a belső szekciót",
  select_profile_image: "Profil kép kiválasztása",
  share_user: "Felhasználó megosztása",
  contact_sender_message:
    "Ossza meg ezt a linket, hogy meghívjon egy nem tagot a Kjuup-ba. Ezt a linket több ember is használhatja a regisztrációhoz.",
  project_sender_message:
    "Ossza meg ezt a linket, hogy meghívjon egy nem tagot a projekt projekt névhez. Ezt a linket több ember is használhatja a regisztrációhoz és a projekt projekt névhez való csatlakozáshoz a Kjuup-ban.",
  company_sender_message:
    "Ossza meg ezt a linket, hogy meghívjon egy nem tagot a cég cég névhez. Ezt a linket több ember is használhatja a regisztrációhoz és a céghez való csatlakozáshoz a Kjuup-ban.",
  contact_receivers_message:
    "Meghívó link a Kjuup-hoz való csatlakozáshoz. Kérjük, kattintson a linkre a kjuup regisztrációjához.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "Abban az esetben, ha a Kjuup-ot az Apple App Store-on keresztül telepíti, a sikeres letöltés után erre a linkre kell kattintania, hogy regisztrálni tudjon.",
  project_receivers_message:
    "Meghívó link a projekt projekt névhez való csatlakozáshoz a Kjuup-ban. Kérjük, kattintson a linkre a Kjuup regisztrációjához és a projekt projekt névhez való csatlakozáshoz.",
  company_receivers_message:
    "Meghívó link a cég cég névhez a Kjuup-ban. Kérjük, kattintson a linkre a Kjuup regisztrációjához és a cég cég névhez való csatlakozáshoz.",
  sign_in: "Bejelentkezés",
  enter_your_email_add: "Adja meg az e-mail címét",
  forgot_password: "Elfelejtette a jelszavát?",
  dont_have_account: "Nincs fiókja?",
  register: "Regisztráció",
  get_app: "Alkalmazás letöltése",
  registration: "Regisztráció",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Építész",
  prof: "Prof.",
  first_name: "Keresztnév",
  last_name: "Vezetéknév",
  have_an_account: "Van fiókja?",
  when_register_you_agree: "Regisztrációkor elfogadja a",
  term_of_use: "felhasználási feltételeinket",
  to: ".",
  in_our: "Az",
  data_policy: "adatvédelmi irányelveinkben",
  they_find_out: "megtudhatja,",
  we_provide_store_data: "hogyan gyűjtjük, feldolgozzuk és tároljuk az információkat.",
  leaving_company_text:
    "Valóban el szeretné hagyni a céget? A cég elhagyásakor az összes kapcsolódó projektet és csevegőcsoportot is elhagyja. Bármikor újra csatlakozhat ezekhez a projektekhez másik céggel.",
  delete_profile_text:
    "Valóban törölni szeretné a profilját? A profil törlésekor az összes kapcsolat a cégekkel, projektekkel és csevegésekkel eltávolításra kerül. Bármikor létrehozhat új profilt.",
  confirm: "Megerősítés",
  reject: "Elutasítás",
  requet_to_leave: "Kérelem a távozáshoz",
  choose: "Választás",
  your_add_member: "Tag hozzáadása",
  if_you: "abban az esetben, ha",
  can_not_find: "nem találja a kapcsolatát itt.",
  please_wait: "Kérjük, várjon..",
  imprint_gtc: "Impresszum/Felhasználási feltételek",
  register_confirm_popup: "Bejelentkezés előtt erősítse meg Kjuup e-mail-címét. Elküldtük a megerősítő linket. Ha nem találja, ellenőrizze a spam mappát is.",
  PENDING_GROUP_USER:
    "csak akkor kap üzeneteket, ha a projekthez való meghívás megerősítve lett. További üzenet jelenik meg, amint a projekthez való meghívás megerősítve lett.",
  PENDING: "A projekthez való meghívás megerősítése függőben",
  denied_group_chat: " elutasította a projekthez való meghívást és elhagyta ezt a csoportot.",
  // joined_group_chat: " csatlakozott a szobához és ehhez a csoporthoz.",
  joined_group_chat: " csatlakozott ehhez a csoporthoz",
  you_joined_group_chat: "Ön csatlakozott ehhez a csoporthoz.",
  Others: "Mások",
  LEFT_GROUP: "elhagyta ezt a csevegőcsoportot.",
  YOU_LEFT_GROUP: "elhagyták ezt a csevegőcsoportot.",
  days: "nap",
  day: "nap",
  hour: "óra",
  hide_project: "Projekt elrejtése",
  hide_project_popup_text:
    "Ha elrejti a projekteket, azok nem találhatók meg a Kjuup-ban. Csak a projekt tagjai hívhatnak meg új felhasználókat a projektbe.",
  branch: "Ág",
  photo_video_media_lib: "Média könyvtár - Fotó és videó",
  document: "Dokumentum",
  location_meeting: "Helyszín / Találkozó",
  all_member_of_project: "A projekt összes tagja",
  pending_request: "Függőben lévő projekt kérések",
  no_pending_request: "Nem található függőben lévő kérelem!",
  news_feed: "Hírfolyam",
  user_info: "Csoport információ",
  leave_project: "Projekt elhagyása",
  media_link_docs: "Fájlok",
  search_chat: "Csevegés keresése",
  export_chat_group: "Csevegőcsoport adatok exportálása az elmúlt hónapból",
  request_complete_chat_history: "Teljes csevegés előzmények kérése",
  leave_chat_group: "Csevegőcsoport elhagyása",
  add_user_project: "Felhasználó hozzáadása",
  me: "Én",
  max_open_one_to_one:
    "Jelenleg max. 2 egy-egy csevegés nyitható párhuzamosan az alsó és felső szekcióban. Összesen max. 4 egy-egy csevegés lehetséges.",
  are_you_sure_you_want_leave_chat:
    "Biztosan el szeretné hagyni ezt a csevegőcsoportot?",
  create_group: "Csoport létrehozása",
  adding_members: "Tagok hozzáadása...",
  creating_the_chat: "Chat létrehozása...",
  finishing_setup: "Befejezés...",
  group_name: "Csoport neve",
  by: "Által:",
  mandetory: "*kötelező",
  delteed: "törölte a profilját és elhagyta a csoportos csevegést.",
  deleted_direct: "törölte a profilját és elhagyta a csevegést.",
  unhidden_message:
    "Ha nem rejti el a projekteket, azok megtalálhatók a Kjuup összes tagjának.",
  account_deleted: "A fiók törölve lett.",
  refuse_company: "Biztosan el szeretné utasítani a cég meghívóját?",
  follow_additional: "További felhasználók követése",
  f_add:
    "Kövessen további Kjuup felhasználókat, hogy elérhetővé tegye őket közvetlen üzenetekhez.",
  c_inv: "Cég meghívó(k)",
  invited_o_Company: "Meghívták, hogy csatlakozzon a céghez",
  refuse_companyX: "Biztosan el szeretné utasítani a cég kérését?",
  a_Da: "Fiók deaktiválva.",
  has_deactivated: "deaktiválta a profilját.",
  reactive: "újraaktiválta a profilját.",
  juup_note: "*Felhasználónévvel való regisztráció csak a Kjuup+ tagok számára elérhető",
  username: "Felhasználónév*",
  email_username: "E-mail/Felhasználónév*",
  sPinText:
    "Kérjük, adjon meg egy 6 számjegyű biztonsági PIN-t. Ez a PIN szükséges lesz, ha elfelejti a jelszavát, és kötelező a fiók megerősítéséhez.",
  DeleteKjuupPlusText:
    "Valóban törölni szeretné a profilját? A profil törlésekor az összes kapcsolat a cégekkel, projektekkel és csevegésekkel eltávolításra kerül.\n\nA fiók törlését követő 48 órán belül újraaktiválhatja a fiókját a felhasználónév, jelszó és PIN megadásával való bejelentkezéssel.",
  reactive_text:
    "A fiókja törölve lett. Kérjük, kattintson az Újraaktiválásra a fiók újraaktiválásához.",
  rac: "Újraaktiválás",
  ac_ss: "A fiók sikeresen újraaktiválva.",
  not_valid_pin: "PIN érvénytelen",
  only_for_kjuup:
    "*Jelszó visszaállítás felhasználónév és PIN segítségével csak a Kjuup+ tagok számára elérhető.",
  resetPIN: "PIN visszaállítása",
  enter_current_pin: "Kérjük, adja meg a jelenlegi PIN-t",
  enter_new: "Adja meg az új PIN-t",
  pin_to_confirm: "Kérjük, adja meg a PIN-t a megerősítéshez.",
  change_username: "Felhasználónév visszaállítása",
  pp_not_match: "A jelszó és a jelszó megerősítése nem egyezik",
  reactive_itself: "Újraaktiválta a profilját.",
  has_deactivated_itself: "Deaktiválta a profilját.",
  more_than_two:
    "Jelenleg a közvetlen üzenetek csak 2 felhasználóval párhuzamosan küldhetők.",
  Chats: "Közvetlen üzenetek",
  only_in_mobileL:
    "A natív videók jelenleg csak mobilalkalmazáson keresztül tölthetők fel és tehetők közzé. Kérjük, használjon Youtube és Vimeo videó linkeket.",
  register_pin_text:
    "Kérjük, válassza ki a személyes 6 számjegyű PIN-t. Ez a PIN szükséges lesz a fiók visszaállítási funkciók engedélyezéséhez.",
  internal_project: "Belső",
  external_projects: "Külső",
  in_deacticted: "A belső szekció deaktiválva.",
  create_article: "Cikk létrehozása",
  new_article_selection: "Cikk létrehozása külső hírfolyamhoz",
  new_article_selection_internal: "Belső cikk létrehozása",
  active_trans_title: "Automatikus fordítás bekapcsolása?",
  active_trans: "Bekapcsoláskor az összes bejövő csevegésüzenet a kiválasztott alkalmazásnyelvre lesz lefordítva.",
  disable_trans: "Valóban deaktiválni szeretné az automatikus fordítást?",
  allow_access_chat: "Teljes csevegés előzmények megjelenítése",
  toggle_chat_history_on:
    "Valóban azt szeretné, hogy a felhasználó lássa a teljes csevegés előzményeket?",
  toggle_chat_history_off:
    "Valóban azt szeretné, hogy a felhasználó csak a csevegéshez való csatlakozás pontjától lássa a csevegés előzményeket?",
  check_selected_settings:
    "Kérjük, ellenőrizze a csevegés előzmények beállításait az összes kiválasztott felhasználóhoz!",
  chat_from_start_have:
    "Ön csatlakozott ehhez a csoporthoz. A csevegés előzmények megosztásra kerültek.",
  chat_from_start_has:
    "csatlakozott ehhez a csoporthoz. A csevegés előzmények megosztásra kerültek.",
  Address: "Cím",
  read_by: "Olvasta",
  deliver_to: "Kézbesítve",
  remaining: "hátralévő",
  message_info: "Üzenet információ",
  request_to_join_only: "Kérelem a csatlakozáshoz",
  unfollow: "Követés megszüntetése",
  company_username: "Felhasználónév",
  month: [
    "Jan",
    "Feb",
    "Már",
    "Ápr",
    "Máj",
    "Jún",
    "Júl",
    "Aug",
    "Sze",
    "Okt",
    "Nov",
    "Dec",
  ],
  remove_my_admin_right: "Adminisztrátor jogaim eltávolítása",
  makeEmp: "Valóban el szeretné távolítani a cég adminisztrátor jogát a felhasználótól?",
  remove_my_self:
    "Valóban el szeretné távolítani a cég adminisztrátor jogát a fiókjából?",
  makeAdmin: "Valóban adni szeretné a felhasználónak a cég adminisztrátor jogát?",
  remove_member: "Tag eltávolítása",
  remove_following_confirm: "Valóban el szeretné távolítani a {name} nevet a követések listájából?",
  remove_follower_confirm: "Valóban el szeretné távolítani {name} a követői listájából? Ha eltávolítja, nem értesítik.",
  do_you_really_want_to_remove:
    "Valóban el szeretné távolítani a felhasználónevet a cégtől?",
  invite_all: "A cég összes tagjának meghívása",
  invite_all_members: "Összes tag meghívása",
  mems: "Minden más tag",
  dep_loc: "Osztály/Helyszín/Csapat",
  depAdmin: "Osztály adminisztrátor",
  add_remove_admin: "Cég adminisztrátor pozíció hozzáadása/eltávolítása",
  add_remove_dep_admin: "Osztály adminisztrátor pozíció hozzáadása/eltávolítása",
  remove_employees_dept: "Alkalmazottak eltávolítása",
  want_to_join_dep:
    "Felhasználónév csatlakozni szeretne a cég companyname Osztály/Helyszín/Csapat depname-hez.",
  you_invited:
    "Meghívták, hogy csatlakozzon a cég companyname Osztály/Helyszín/Csapat depname-hez.",
  dep_remove:
    "Valóban el szeretné távolítani az osztály vagy helyszín adminisztrátor jogát a felhasználótól?",
  add_dep:
    "Valóban adni szeretné a felhasználónak az osztály vagy helyszín adminisztrátor jogát?",
  my_self_dep_remove:
    "Valóban el szeretné távolítani az osztály adminisztrátor jogát a fiókjából?",
  member: "Tag",
  admin: "Adminisztrátor",
  remove_project_admin:
    "Valóban el szeretné távolítani a tagot a projektből?",
  remove_my_self_project: "Valóban el szeretné távolítani az adminisztrátor jogot?",
  remove_member_admin_right:
    "Valóban el szeretné távolítani az adminisztrátor jogot a felhasználótól?",
  add_member_admin_right: "Valóban hozzá szeretné adni az adminisztrátor jogot a felhasználóhoz?",
  add_remove_Poss: "Adminisztrátor pozíció hozzáadása/eltávolítása",
  forward: "Továbbítás",
  edit: "Szerkesztés",
  only_kjuup_plus_can: "Csak a Kjuup+ cégek tehetnek közzé cikkeket.",
  add_images: "Kép(ek) hozzáadása",
  request_confirmation: 'Függőben lévő projekt meghívók',
  Activity: "Aktivitás",
  latest_messages: "Legújabb üzenetek",
  hours: "óra",
  minute: "perc",
  seconds: "másodperc",
  days: "nap",
  yesterday: "tegnap",
  last_week: "múlt héten",
  next_week: "következő héten",
  Last_month: "múlt hónapban",
  All: "Összes",
  register_plus: "Regisztráció Plus",
  select_files: "Fájlok kiválasztása",
  monthsFullName: [
    "Január",
    "Február",
    "Március",
    "Április",
    "Május",
    "Június",
    "Július",
    "Augusztus",
    "Szeptember",
    "Október",
    "November",
    "December",
  ],
  company_deploc_receivers_message:
    "Meghívó link a cég company name osztályához a Kjuup-ban. Kérjük, kattintson a linkre a Kjuup regisztrációjához és a cég company name-hez való csatlakozáshoz.",
  no_news: "Nincs elérhető hír",
  reminder: "Emlékeztető",
  np_reminder: "Nincs feladat",
  move_to_reminder: "Áthelyezés feladatba",
  remove_reminder: "Valóban el szeretné távolítani ezt az üzenetet a feladatlistájából?",
  remove_all_reminder: "Összes feladat eltávolítása",
  remove_all_confirm: "Valóban el szeretné távolítani az összes üzenetet a feladatlistájából?",
  remove_from_reminder: "Eltávolítás az emlékeztetőből",
  prevent_email: "Az E-mail nem használható Felhasználónévként.",
  allow_noti: "Kérjük, engedélyezze az értesítéseket.",
  join_cap: "Csatlakozás",
  pass_minimum:
    "**A jelszó 12 karaktert igényel, beleértve a kis-, nagybetűt, számot és speciális karaktert.",
  pass_error: "Kérjük, ellenőrizze a jelszó követelményeket",
  people_that_like_article: "Emberek, akiknek tetszik a cikk.",
  people_who_like_article: "Emberek, akiknek tetszik a cikke.",
  message_delete: "Ez az üzenet törölve lett.",
  message_edited: "szerkesztve",
  edit_message: "Üzenet szerkesztése",
  edit_window_expired: "Az üzenetek csak a küldéstől számított 10 percen belül szerkeszthetők.",
  message_edit_save: "Mentés",
  copy: "Másolás",
  bookmark: "Könyvjelző",
  add_reaction: "Reakció hozzáadása",
  delete_message: "Üzenet törlése",
  more_options: "További lehetőségek",
  info: "Infó",
  link_invite: "Meghívás linken keresztül",
  ll_nkk: "Meghívás a Kjuup-ba",
  selected: "Kiválasztva",
  is_active: "Aktív",
  inactive: "Inaktív",
  last_online: "utoljára online {{when}}",
  remove_user_l: "Eltávolítás",
  link_expire: "Minden generált link 72 órán keresztül érvényes lesz.",
  company_language: "Cég nyelve",
  company_language_info:
    "A nyelv kiválasztása minden cégre vonatkozó e-mail megerősítéshez használatos.",
  s_image: "kép",
  m_image: "képek",
  removeMsg: "Érintse az eltávolításhoz",
  block: 'Blokkolás',
  unblock: 'Blokkolás feloldása',
  blocks: 'Biztosan blokkolni szeretné ezt a felhasználót?',
  unblocks: 'Biztosan fel szeretné oldani ezt a felhasználó blokkolását?',
  bolcked_click_un_block:
    'Blokkolta ezt a kapcsolatot. Kattintson ide a blokkolás eltávolításához.',
  you_have_unblocked: 'Feloldotta ezt a kapcsolat blokkolását.',
  you_have_blocked: 'Blokkolta ezt a kapcsolatot.',
  unblock_to_send: 'Oldja fel a felhasználó blokkolását az üzenet küldéséhez.',
  pilot_text: "Specializált AI építési témákhoz",
  startup_screen_label: "Kezdőképernyő",
  startup_screen_info: "Válassza ki, melyik képernyő nyílik meg a Kjuup indításakor.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Üzenetek",
  startup_screen_saved: "Kezdőképernyő frissítve",
email_on: "E-mail értesítések csevegések",
  email_on_grp: "E-mail értesítés",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Aktiválja vagy deaktiválja az e-mail értesítéseket ehhez a projekthez. Ez az opció csak akkor érhető el, ha az \"E-mail értesítések csevegések\" engedélyezve van a személyes beállításokon keresztül.",
  todo_notification_info: "Értesítést kapsz, valahányszor új feladatot rendelnek hozzád.",
  info_val: "E-mailt kapsz, ha egy új csevegőüzenetet rövid időn belül nem olvasol el. Ezt egyes projektekhez vagy csevegésekhez a beállításaikban vagy a csevegőcsoport információiban kapcsolhatod ki.",
  email_groups: "Aktiválja vagy deaktiválja az e-mail értesítéseket ehhez a csevegéshez. Ez az opció csak akkor érhető el, ha az \"E-mail értesítések csevegések\" engedélyezve van a személyes és projekt beállításokon keresztül.",
  add_update_email: "E-mail hozzáadása/frissítése",
  text_to_verifiy: "Az \"E-mail értesítések csevegések\" opció csak akkor engedélyezhető, ha van ellenőrzött e-mail címe a fájlban.",
  stored_email: "Tárolt e-mail: ",
  verify_email: "Megerősítés függőben!",
  join_call:"Csatlakozás",
  call_is_started:"A hívás elindult",
  start_chat:"Közvetlen csevegés indítása?",
  project_rooms:"Projektek",
  download_selected:"Letöltés",
  add_employee_confirm: 'Biztosan hozzá szeretné adni ezt a felhasználót a céghez?',
  invalid_deeplink: "Érvénytelen mély link URL. Hiányoznak a szükséges paraméterek.",
  deeplink_error: "Nem lehet feldolgozni a mély linket. Kérjük, próbálja újra később.",
  // Reply functionality translations
  reply: "Válasz",
  reply_enter: "Adja meg a választ...",
  reply_sent_successfully: "Válasz sikeresen elküldve",
  reply_failed: "A válasz küldése sikertelen",
  reply_failed_generic: "A válasz küldése sikertelen. Kérjük, próbálja újra.",
  replying_to_message: "Válasz az üzenetre",
  cancel_reply: "Válasz megszakítása",
  voice_message: "Hangüzenet",
  send: "Küldés",
  cancel: "Mégse",
  type_your_reply: "Írja be a válaszát...",
  
  // Auto-suggestion translations
  suggested_replies: "Javasolt válaszok",
  suggestions_error: "A javaslatok betöltése sikertelen",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "Egy pillanat. A szövegét egyénileg készítjük elő.",
  loading_chat_message: "Csevegés betöltése...",
  
  // Manual ToDo translations
  extracting_message: "Üzenet kinyerése...",
  create_todo: "Feladat létrehozása",
  create_todo_confirmation: "Szeretne feladatot létrehozni ebből az üzenetből?",
  select_project_required: "Kérjük, válasszon projektet/csoportot",
  only_assigned_can_change_status: "Csak a hozzárendelt felhasználók változtathatják meg az állapotot",
  todo_summary: "Összefoglaló",
  todo_summary_placeholder: "Adja meg a feladat összefoglalóját...",
  todo_date: "Dátum",
  todo_time: "Idő",
  todo_date_hint: "Hagyja üresen az eredeti üzenet dátum/idő használatához",
  todo_created_success: "Feladat sikeresen létrehozva",
  todo_creation_failed: "A feladat létrehozása sikertelen",
  create: "Létrehozás",
  
  image: "kép",
  images: "képek",
  remove_all_images: "Összes kép eltávolítása",
  remove_image: "Kép eltávolítása",
  remove_document: "Dokumentum eltávolítása",
  remove_recording: "Felvétel eltávolítása",
  play_recording: "Felvétel lejátszása",
  upload_image: "Kép feltöltése",
  upload_document: "Dokumentum feltöltése",
  record_audio: "Hang rögzítése",
  stop_recording: "Felvétel leállítása",
  stop_recording_text: "Felvétel leállítása",
  please_remove_current_attachment: "Kérjük, távolítsa el a jelenlegi mellékletet",
  please_upload_image_file: "Kérjük, töltsön fel érvényes képfájlt",
  please_upload_valid_document: "Kérjük, töltsön fel érvényes dokumentumfájlt",
  searching_messages: "Üzenetek keresése...",
  loading_more: "Több betöltése...",
  loading_more_users: "Több felhasználó betöltése...",
  load_more_users: "Több felhasználó betöltése",
  no_more_users_to_load: "Nincs több betölthető felhasználó",
  no_messages_found: "Nem találhatók üzenetek",
  try_different_keyword: "Próbáljon másik kulcsszót vagy ellenőrizze a helyesírást.",
  search_messages: "Üzenetek, csevegőcsoportok, projekttermek és felhasználók keresése...",
  todo: "Feladat",
  np_todo: "Nincs feladat",
  move_to_todo: "Mentés feladatként",
  remove_todo: "Valóban el szeretné távolítani a feladatot?",
  remove_all_todo: "Összes feladat eltávolítása",
  remove_all_todo_confirm: "Valóban el szeretné távolítani az összes feladatot?",
  add_to_todo: "Hozzáadás a feladathoz",
  remove_from_todo: "Eltávolítás a feladatból",
  confirm: "Megerősítés",
  ok: "Ok",
  read_more: "Többet olvas",
  show_less: "Kevesebbet mutat",
  show_more: "Több mutatása",
  audio: "Hang",
  video: "Videó",
  // Notification Settings
  notification_schedule: "Értesítési ütemezés",
  notification_schedule_desc: "Csak az Ön által választott órákban kap push és e-mail értesítéseket. Ezen időn kívül szünetelnek.",
  learn_more: "További információ",
  allow_notifications: "Értesítések engedélyezése:",
  every_day: "Minden nap",
  weekdays: "Hétköznapok (hétfőtől péntekig)",
  custom: "Egyedi",
  monday: "Hétfő",
  tuesday: "Kedd",
  wednesday: "Szerda",
  thursday: "Csütörtök",
  friday: "Péntek",
  saturday: "Szombat",
  sunday: "Vasárnap",
  to: "ig",
  notification_settings: "Értesítések",
  notification_settings_saved: "Értesítési beállítások sikeresen mentve",
  notification_settings_error: "Az értesítési beállítások mentése sikertelen",
  unavailability_note: "Távolléti értesítés",
  unavailability_description: "Állítson be egy irodán kívüli értesítést. Amíg aktív, az értesítés megjelenik másoknak az összes csevegésében, és az értesítések szünetelnek.",
  unavailability_start_date: "Kezdő dátum",
  unavailability_end_date: "Befejezési dátum",
  unavailability_message: "Üzenet",
  unavailability_message_hint: "Használja az {endDate} helyőrzőt a visszatérés dátumához.",
  unavailability_replacement: "Helyettesítő kontakt",
  unavailability_replacement_placeholder: "Adja meg a felhasználói azonosítót sürgős kérésekhez",
  unavailability_replacement_current: "Jelenlegi helyettes",
  unavailability_replacement_hint: "Ha be van állítva, a távolléti értesítésben megjelenik egy link ennek a személynek a sürgős ügyekben történő eléréséhez.",
  unavailability_replacement_none: "Nincs helyettes (opcionális)",
  unavailability_contact_urgent: "Sürgős kérések esetén forduljon",
  unavailability_default_message: "Jelenleg nem vagyok az irodában, és nem férek hozzá a Kjuuphoz. {endDate} dátumtól újra elérhető leszek, és akkor jelentkezem.",
  unavailability_save: "Mentés",
  unavailability_deactivate: "Deaktiválás",
  unavailability_active_until: "Aktív eddig",
  unavailability_saved: "Távolléti értesítés mentve",
  unavailability_save_error: "A távolléti értesítés mentése sikertelen",
  unavailability_deactivated: "Távolléti értesítés deaktiválva",
  unavailability_end_date_required: "A befejezési dátum megadása kötelező",
  start_time_before_end_time: "A kezdési időnek a befejezési idő előtt kell lennie",
  loading: "Betöltés",
  disabled: "Letiltva",
  enable: "Engedélyezés",
  disable: "Letiltás",
  forwarded: "Továbbítva",
  message_forwarded: "Üzenet továbbítva!",
  // Schedule Article
  schedule_article_post: "Cikk közzététel ütemezése",
  date: "Dátum",
  time: "Idő",
  scheduled_for_publication: "Ütemezve közzétételre",
  article_will_be_published_on: "A cikk közzé lesz téve:",
  reset_selection: "Kiválasztás visszaállítása",
  continue: "Folytatás",
  cancel: "Mégse",
  // Member Selection
  error_loading_members: "Hiba a tagok betöltésekor",
  please_fill_all_fields: "Kérjük, töltse ki az összes mezőt",
  invalid_email: "Érvénytelen e-mail cím",
  member_added_successfully: "Tag sikeresen hozzáadva",
  error_onboarding_user: "Hiba a felhasználó hozzáadásakor",
  error_creating_chat: "Hiba a csevegés létrehozásakor",
  error_creating_group: "Hiba a csoport létrehozásakor",
  new_group: "Új csoport",
  please_select_or_enter_group_name: "Kérjük, válasszon csoportot vagy adja meg a csoport nevét",
  please_select_or_enter_room_name: "Kérjük, válasszon projektet vagy adja meg a projekt nevét",
  error_creating_room: "Hiba a projekt létrehozásakor",
  error_opening_chat: "Hiba a csevegés megnyitásakor",
  privacy_modal_text: "Válassza a \"Privát\" opciót csak akkor, ha a csevegés nem tartalmaz releváns szakmai tartalmat a projektmenedzser számára.",
  not_private: "Nem privát",
  private: "Privát",
  error_loading_groups: "Hiba a csoportok betöltésekor",
  automatic_chat_export: "Automatikus csevegés exportálás",
  automatic_chat_export_info: "Aktiválás után a csevegés előzmények automatikusan elküldésre kerülnek a megadott e-mail címre minden hónapban.",
  automatic_chat_export_no_email: "Az automatikus csevegés exportálás engedélyezéséhez először hozzá kell adnia egy e-mail címet. E-mail címét a személyes beállításokban adhatja hozzá.",
  enter_email: "Adja meg az e-mailt",
  update: "Frissítés",
  confirm: "Megerősítés",
  export_to_email: "Az export a következő e-mailre megy.",
  start_chat_button:"Új üzenet",
  matching_existing_chats: "Megfelelő meglévő csevegések",
  subject: "Tárgy",
  add_subject: "Tárgy hozzáadása",
  chat_subject: "Csevegés tárgya:",
  set_project_room: "Projekt beállítása",
  matching_existing_project_rooms: "Megfelelő meglévő projektek",
  name_project_room: "Projekt elnevezése",
  professional_or_private: "Szakmai vagy privát",
  professional: "Szakmai",
  privacy_modal_text_updated: "Válassza a \"Privát\" opciót csak akkor, ha a csevegés nem tartalmaz releváns szakmai tartalmat a projektmenedzserek számára. A privát csevegések nem láthatók a projektmenedzserek számára.",
  create_internal_chat: "Külső - vagy belső csevegés?",
  internal_chat_description: "Csak a cég alkalmazottai adhatók hozzá belső csevegésekhez.",
  yes: "Igen",
  no: "Nem",
  chat_is_being_created: "A csevegés létrehozása folyamatban...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Valóban el szeretné vetni a cikk módosításait?",
  please_enter_article_title: "Kérjük, először adja meg a cikk címét.",
  please_add_mandatory_fields: "Kérjük, adja hozzá az összes kötelező mezőt",
  product_label: "Termék:",
  no_companies_found: "Nem találhatók cégek",
  visible_to_all_followers: "Látható minden Kjuup tag számára",
  only_visible_to_employees: "Csak alkalmazottak számára látható",
  something_went_wrong: "Valami hiba történt, kérjük próbálja újra",
  please_select_department: "Kérjük, válasszon osztályt/helyszínt",
  schedule: "Ütemezés",
  please_select_future_date_time: "Kérjük, válasszon jövőbeli dátumot és időt a cikk ütemezéséhez.",
  please_select_different_date_time: "Kérjük, válasszon másik dátumot vagy időt a cikk ütemezéséhez.",
  please_select_later_time: "Kérjük, válasszon ma későbbi időt, mint a jelenlegi idő.",
  unpin_article: "Cikk rögzítésének megszüntetése",
  pin_article: "Cikk rögzítése",
  and: "és",
  others: "mások",
  at: "kor",
  // Chat mute/unmute translations
  mute: "Némítás",
  unmute: "Némítás feloldása",
  chat_muted_successfully: "Csevegés sikeresen némítva",
  chat_unmuted_successfully: "A csevegés némítása sikeresen feloldva",
  mute_chat_confirm: "Valóban némítani szeretné ezt a csevegést? Többé nem kap értesítéseket az új üzenetekről.",
  unmute_chat_confirm: "Valóban fel szeretné oldani ezt a csevegés némítását? Újra kap értesítéseket az új üzenetekről.",
  please_select_group_to_forward: "Kérjük, válasszon csoportot az üzenet továbbításához",
  // Company translations
  record_not_found: "A rekord nem található!",
  please_select_position: "Kérjük, válasszon pozíciót",
  delete_article_confirm: "Biztosan törölni szeretné ezt a cikket?",
  delete_company_service_confirm: "Biztosan törölni szeretné a cég szolgáltatását?",
  block_translation_confirm: "Valóban blokkolni szeretné az automatikus fordítást a projektekben a cég összes tagja számára",
  unblock_translation_confirm: "Valóban fel szeretné oldani az automatikus fordítás blokkolását a projektekben a cég összes tagja számára",
  please_select_file: "Kérjük, válasszon fájlt a feltöltéshez",
  role_in_building_industry: "Szerep az építőiparban*",
  invalid_email_address: "Érvénytelen e-mail cím",
  please_enter_password: "Kérjük, adja meg a jelszavát",
  password_change_email_sent: "E-mailt küldtünk a Kjuup e-mail címére. Erősítse meg az új jelszavát az e-mailben található megerősítő linkre kattintva.",
  please_enter_username: "Kérjük, adja meg a felhasználónevet",
  username_same_as_before: "A felhasználónév nem lehet ugyanaz, mint korábban",
  profile_deleted_successfully: "Profil sikeresen törölve",
  hardware_requirements: "Hardver követelmények",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU sebesség min. 2GHz<br/>• Windows 7 vagy újabb / minden macOS verzió",
  submitting: "Küldés...",
  signing_in: "Bejelentkezés...",
  please_enter_service_name: "Kérjük, adja meg a szolgáltatás nevét",
  something_went_wrong_error: "Aaaah! Valami hiba történt...",
  something_went_wrong_try_again: "Sajnáljuk, valami hiba történt ott. Próbálja újra",
  position_label: "Pozíció:",
  loading_room: "Projekt betöltése...",
  navigating_to_room: "Navigálás a projekthez",
  loading_chat: "Csevegés betöltése...",
  translate: "Fordítás",
  show_original: "Eredeti megjelenítése",
  saving: "Mentés...",
  language_selection_info: "A nyelv kiválasztása minden cégre vonatkozó e-mail megerősítéshez használatos.",
  // Navigation bar labels
  nav_call: "Hívás",
  nav_home: "Kezdőlap",
  nav_messages: "Üzenetek",
  nav_todo: "Feladatok",
  nav_rooms: "Projektek",
  nav_all_rooms: "Összes projekt",
  pinned_rooms_max: "Legfeljebb 10 projektet rögzíthet.",
  pinned_room_unpin: "Feloldás",
  pinned_rooms_drop: "Húzza ide a projektjét a gyors kiválasztáshoz",
  nav_profile: "Profil",
  nav_company: "Cég",
  nav_company_documents: "Dokumentumok",
  nav_logout: "Kijelentkezés",
  // Create message dialog
  add_member_title: "Tag hozzáadása",
  continue_btn: "Folytatás",
  search_placeholder: "Keresés",
  no_members_found: "Nem találhatók tagok",
  no_groups_found: "Nem találhatók csoportok",
  no_rooms_found: "Nem találhatók projektek",
  search_users_tab: "Felhasználók",
  search_documents_tab: "Dokumentumok",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Nincsenek fájlok",
  no_documents_available: "No documents",
  searching_users: "Felhasználók keresése...",
  no_users_found: "Nem található felhasználó",
  search_emails_tab: "E-mail",
  searching_emails: "E-mailek keresése...",
  no_emails_found: "Nem található e-mail",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Névtelen csoport",
  unnamed_room: "Névtelen projekt",
  all_members: "Összes",
  room_label: "Projekt:",
  subject_label: "Tárgy:",
  no_members: "Nincs tag",
  // Loading states for room creation
  creating_structure: "Struktúra létrehozása",
  opening_chat: "Csevegés megnyitása",
  please_wait: "Kérjük, várjon...",
  // ToDo page translations
  loading_todo: "ToDo betöltése...",
  task_updated: "Feladat frissítve",
  error_updating_task: "Hiba a feladat frissítésekor",
  task_deleted: "Feladat törölve",
  error_deleting_task: "Hiba a feladat törlésekor",
  delete_task_confirm: "Biztosan törölni szeretné ezt a feladatot?",
  description_label: "Leírás",
  description_placeholder: "Adja meg a leírást...",
  date_time_label: "Dátum és idő",
  save_hint: "Ctrl+Enter a mentéshez, Esc a megszakításhoz",
  edit_label: "Szerkesztés",
  delete_label: "Törlés",
  todo_list_title: "Feladatok",
  tasks_count: "feladat",
  search_placeholder_todo: "Keresés...",
  select_task_to_open_chat: "Válasszon feladatot a csevegés megnyitásához",
  today: "Ma",
  yesterday: "Tegnap",
  time_suffix: "", // Empty for Hungarian (24h format doesn't need suffix)
  from_chat: "Forrás feladat",
  assigned_to: "Hozzárendelve",
  assign_users: "Felhasználók hozzárendelése",
  no_users_assigned: "Nincs hozzárendelt felhasználó",
  assign: "Hozzárendelés",
  assign_to: "Hozzárendelés...",
  navigate_to_chat: "Navigálás a csevegéshez",
  navigate_to_email: "Ugrás az e-mailre",
  show_original_message: "Forrás megjelenítése",
  hide_original_message: "Forrás elrejtése",
  status_pending: "Függőben",
  status_in_progress: "Folyamatban",
  status_completed: "Befejezve",
  show: "Megjelenítés",
  close: "Bezárás",
  // Log translation strings
  status_confirmed: "[Megerősítve]",
  log_todo_created: "Feladat [létrehozva]",
  log_todo_confirmed: "Feladat [megerősítve]",
  log_todo_deleted: "Feladat [törölve]",
  log_todo_updated: "Feladat [frissítve]",
  log_description_updated: "[Leírás frissítve]",
  log_deadline_updated: "[Határidő frissítve]",
  log_assigned_to: "[Hozzárendelve] {name}",
  log_unassigned_from: "[Hozzárendelés megszüntetve] {name}",
  log_assignment_added: "[Hozzárendelés hozzáadva]: {name}",
  log_assignment_removed: "[Hozzárendelés eltávolítva]: {name}",
  log_status_updated: "[Állapot módosult] {from} [-ról/-ről] {to} [-ra/-re]",
  log_status_changed: "[Állapot módosult]",
  log_status_changed_to: "[Állapot módosult erre:] {status}",
  log_changed_status_to: "[Állapotot módosította erre:]",
  log_for_user: "[felhasználó számára]:",
  log_user_updated_status: "[Felhasználó frissítette a feladat állapotát]",
  log_changed_date_to: "[Dátumot módosította erre:]",
  log_changed_description_to: "[Leírást módosította erre:]",
  log_moved_to: "[Áthelyezve ide:] {status}",
  todo_status_updated_from: "[-ról/-ről]",
  todo_status_updated_to: "[-ra/-re]",
  filter_pending: "Függőben",
  filter_confirmed: "Megerősítve",
  filter_assigned_to_me: "Feladataim",
  filter_assigned_by_me: "Delegált",
  todo_project_label: "Projekt:",
  assigned_users: "Hozzárendelt felhasználók:",
  todo_chat_label: "Csevegés:",
  history: "Előzmények",
  todo_assigned_by: "Kiosztotta:",
  todo_assigned_push: "Hozzárendelt ToDo:",
  todo_assigned_push_empty: "Új ToDo-t rendeltek hozzád.",
  search_groups: "Csoportok",
  search_chat_groups: "Chat csoportok",
  search_project_room: "Projekt",
  search_messages_tab: "Üzenetek",
  searching_groups: "Csoportok keresése...",
  searching_rooms: "Projektek keresése...",
  no_groups_found: "Nem található csoport",
  no_rooms_found: "Nem található projekt",
  create_poll: "Szavazás",
  poll_question_label: "KÉRDÉS",
  poll_question_placeholder: "Tegyen fel egy kérdést",
  poll_options_label: "LEHETŐSÉGEK",
  poll_option: "Lehetőség",
  poll_add_option: "Lehetőség hozzáadása",
  poll_allow_multiple: "Több válasz engedélyezése",
  poll_multiple_allowed: "Válasszon egy vagy több lehetőséget",
  poll_select_option: "Válasszon egy lehetőséget",
  poll_view_votes: "Szavazatok megtekintése",
  poll_vote_singular: "szavazat",
  poll_vote_plural: "szavazat",
  poll_votes: "Szavazási eredmények",
  poll_no_votes_yet: "Még nincsenek szavazatok",
  transcript_step_processing: "Átírás folyamatban...",
  ai_transcript_tab: "AI-Átírás",
  ai_transcript_info: "Csak a 2026.03.09. után létrehozott hangüzenetekhez érhető el.",
  transcript_more: "...több",
  transcript_less: "...kevesebb",
  ki_transcript_voice_message: "KI-Hangüzenet átirata",
  ki_image_analysis: "AI-alapú képelemzés",
  type_message: "Írjon üzenetet",
  email_tab_messages: "Üzenetek",
  email_tab_email: "E-mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "E-mail fiókok",
  email_connect_gmail: "Gmail csatlakoztatása",
  email_connect_outlook: "Outlook csatlakoztatása",
  email_no_accounts: "Nincs csatlakoztatott e-mail fiók",
  email_no_accounts_hint: "Csatlakoztasson egy e-mail fiókot a profilbeállításokban",
  email_no_messages: "Nincs e-mail",
  email_from: "Feladó",
  email_to: "Címzett",
  email_subject: "Tárgy",
  email_disconnect: "Leválasztás",
  email_disconnect_confirm: "Biztosan leválasztja ezt az e-mail fiókot? Minden szinkronizált e-mail törlésre kerül.",
  email_account_disconnected: "Az e-mail fiók sikeresen leválasztva",
  email_account_disconnect_failed: "Nem sikerült leválasztani a fiókot",
  email_connecting: "Csatlakozás...",
  email_account_connected: "Fiók sikeresen csatlakoztatva",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Ugrás a beállításokhoz",
  email_date: "Dátum",
  email_reply: "Válasz",
  email_forward: "Továbbítás",
  email_copy_text: "Szöveg másolása",
  email_text_copied: "Másolva!",
  email_text_copy_failed: "A szöveget nem sikerült másolni.",
  email_delete: "Törlés",
  email_not_spam: "Nem spam",
  email_not_spam_success: "E-mail áthelyezve a beérkezett üzenetek közé.",
  email_not_spam_failed: "Nem sikerült áthelyezni a beérkezett üzenetek közé.",
  email_delete_confirm: "Biztosan törölni szeretné ezt az e-mailt?",
  email_delete_from_folder: "Biztosan törölni szeretné innen: {folder}?",
  email_delete_permanent_from_folder:
    "Biztosan véglegesen törölni szeretné innen: {folder}? Ez a művelet nem vonható vissza.",
  email_save_draft_confirm: "Szeretné ezt az e-mailt piszkozatként menteni?",
  email_save_draft: "Piszkozat mentése",
  email_discard: "Elvetés",
  email_back_to_compose: "Vissza az íráshoz",
  email_draft_saved: "Piszkozat mentve.",
  email_draft_save_failed: "Nem sikerült menteni a piszkozatot.",
  email_loading: "E-mailek betöltése...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Kijelölés",
  email_attachment_singular: "Melléklet",
  email_attachment_plural: "Mellékletek",
  email_back: "Vissza",
  email_download: "Letöltés",
  email_close: "Bezárás",
  email_preview: "Előnézet",
  email_preview_not_available: "Az előnézet nem érhető el",
  email_preview_failed: "Az előnézet nem érhető el",
  select_attachments: "Mellékletek kiválasztása",
  email_loading_preview: "Előnézet betöltése...",
  email_mark_unread_failed: "e-mail(ek) nem jelölhetők olvasatlanként.",
  email_delete_failed: "e-mail(ek) nem törölhetők.",
  filter_all: "Összes",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Közvetlen üzenetek",
  my_notes: "My Space",
  filter_internal_groups: "Belső csoportos chatek",
  filter_external_groups: "Külső csoportos chatek",
  filter_group_chats: "Csoportos chatek",
  filter_groups_internal: "Belső",
  filter_groups_external: "Külső",
  filter_unread_only: "Csak olvasatlan",
  room_daily_briefing_info: "Ha engedélyezve van, a projekt jelentése 24 óránként a személyes beállításokban megadott időpontban készül — de csak akkor, ha abban az időszakban volt tevékenység.",
  email_select_all: "Összes kijelölése",
  email_deselect_all: "Kijelölés megszüntetése",
  email_reply_all: "Válasz mindenkinek",
  email_reply_placeholder: "Írja be válaszát...",
  email_forward_placeholder: "Üzenet hozzáadása...",
  email_edit_draft: "Piszkozat szerkesztése",
  email_attach: "Csatolás",
  email_attachment_from_original: "Az eredeti üzenetből",
  email_remove: "Eltávolítás",
  email_drop_files: "Húzza ide a fájlokat csatoláshoz",
  email_loading_attachments: "Mellékletek betöltése...",
  email_archive: "Archiválás",
  mark_unread: "Megjelölés olvasatlanként",
  mark_read: "Megjelölés olvasottként",
  email_all_accounts: "Összes fiók",
  email_error: "Hiba",
  email_delete_email_failed: "Az e-mail törlése nem sikerült.",
  enter_url: "Adja meg az URL-t",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Iratkozz fel most',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 HÓNAP INGYENES PRÓBA',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Ma nincs fizetés. Bankkártyaadatok nem kerülnek bekérésre a fizetős előfizetés indulása előtt.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Kezeld az összes e-mail fiókot közvetlenül a Kjuupban',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'A MI megírja a válaszokat – te csak megerősíted',
  kjuup_io_feature_tasks: 'Feladatok és naptár mindig automatikusan naprakész',
  kjuup_io_choose_plan: 'Válassz csomagot',
  kjuup_io_plan_monthly: 'Havi',
  kjuup_io_plan_yearly: 'Éves',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Stripe által védve · bármikor lemondható',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Fizetés beérkezett. Az előfizetés aktiválása folyamatban…',
  kjuup_io_toast_activating_soon: 'Fizetés beérkezett. Az előfizetése hamarosan aktiválódik.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} óra van hátra',
  kjuup_io_trial_left_hour: '1 óra van hátra',
  kjuup_io_trial_left_minutes: '{count} perc van hátra',
  kjuup_io_trial_left_minute: '1 perc van hátra',
  kjuup_io_trial_left_seconds: '{count} másodperc van hátra',
  kjuup_io_trial_left_second: '1 másodperc van hátra',
  kjuup_io_trial_ending_now: 'A próbaidőszak véget ér…',
  kjuup_io_request_timeout: 'A kapcsolat időtúllépés miatt megszakadt. Próbálja újra.',
  kjuup_io_info_days_free: '{days} nap teljesen ingyen – az előfizetés csak a próba után indul.',
  kjuup_io_discount_total: 'Kedvezményed: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Személyes: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Bezárás',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Az ingyenes próbaidőszak véget ért',
  kjuup_io_trial_ended_body: 'Fizessen elő a Kjuup.io-ra, hogy továbbra is használhassa az e-mailt és a többi prémium funkciót.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Az ingyenes próbaidőszak elkezdődött',
  kjuup_io_toast_trial_fail: 'A próbaidőszak nem indítható el',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / hónap',
  kjuup_io_save_amount_year: 'Spórolj {price}-t évente',
  kjuup_io_billed_annually_amount: '{price} évente számlázva',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Amit kapsz:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Nincs szükség bankkártyára – azonnal indulhatsz fizetési adatok nélkül.',
  kjuup_io_info_cancel_anytime: 'Bármikor lemondható – nincs kötelezettség, nincs kockázat.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Számlázási időszak',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Fizetési mód mentve. A terhelés a próbaidőszak végén történik.',
  calendar_sync_info: 'Szinkronizáld automatikusan az összes Kjuup ToDo-t a naptáraddal.',
  calendar_no_accounts: 'Még nincs naptár csatlakoztatva.',
  article_new_badge: 'ÚJ',
  article_new_posts: '{0} új bejegyzés',
  documents: 'Dokumentumok',
  add_documents: 'Dokumentumok hozzáadása',
  no_preview_available: 'Nincs elérhető előnézet',
  no_preview_hint: 'Ez a fájltípus nem tekinthető meg előnézetben, de a küldés így is megtörténik.',
  max_documents_reached: 'Egyszerre legfeljebb 10 dokumentumot csatolhatsz.',
  open_file: 'Fájl megnyitása',
  twofa_title: 'Kétlépcsős azonosítás',
  twofa_method_totp: 'Hitelesítő alkalmazás',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-mail',
  twofa_enter_app: 'Add meg a 6 számjegyű kódot a hitelesítő alkalmazásból.',
  twofa_enter_sms: 'Add meg a 6 számjegyű kódot, amelyet SMS-ben küldtünk.',
  twofa_enter_email: 'Add meg a 6 számjegyű kódot, amelyet e-mailben küldtünk.',
  twofa_resend: 'Kód újraküldése',
  twofa_try_another: 'Másik módszer',
  twofa_remember_device: 'Ezen az eszközön 30 napig ne kérdezzen',
  twofa_sent: 'Elküldtünk egy kódot.',
  twofa_invalid_code: 'Ez a kód helytelen. Próbáld újra.',
  twofa_something_wrong: 'Valami hiba történt. Próbáld újra.',
  twofa_method_unavailable: 'Ez a módszer nem érhető el.',
  twofa_on_desc: 'A kétlépcsős azonosítás be van kapcsolva. Minden bejelentkezéskor kód kell.',
  twofa_off_desc: 'Adj egy második lépést a jelszó után. A hitelesítő alkalmazások a legbiztonságosabbak.',
  twofa_methods: 'Módszerek',
  twofa_on: 'Be',
  twofa_add: 'Hozzáadás',
  twofa_default_method: 'Alapértelmezett módszer',
  twofa_default: 'Alapértelmezett',
  twofa_turn_off: 'Kikapcsolás',
  twofa_disable_hint: 'Add meg a jelszavad és egy aktuális kódot a kétlépcsős azonosítás kikapcsolásához.',
  twofa_disable_need: 'Add meg a jelszavad és egy ellenőrző kódot.',
  twofa_code_placeholder: '6 számjegyű kód vagy tartalékkód',
  twofa_send_code: 'Kód küldése',
  twofa_primary_updated: 'Az alapértelmezett módszer frissült.',
  twofa_disabled: 'A kétlépcsős azonosítás ki van kapcsolva.',
  twofa_enabled: 'A kétlépcsős azonosítás be van kapcsolva.',
  twofa_totp_help: 'Olvasd be ezt a QR-kódot a Google Authenticator, Authy vagy 1Password alkalmazással. A kulcsot kézzel is megadhatod.',
  twofa_secret_copied: 'Kulcs másolva',
  twofa_sms_help: 'Add meg a számod nemzetközi formátumban. 6 számjegyű kódot küldünk SMS-ben.',
  twofa_email_help: '6 számjegyű kódot küldünk a fiókod e-mail-címére.',
  twofa_backup_title: 'Tartalékkódok',
  twofa_backup_help: 'Tárold ezeket az egyszer használatos kódokat biztonságos helyen. Mindegyik egyszer használható, ha elveszik a telefonod.',
  twofa_copy_codes: 'Kódok másolása',
  twofa_codes_copied: 'Tartalékkódok másolva',
  twofa_regenerate: 'Új biztonsági kódok kérése',
  twofa_regenerate_hint: 'Ez lecseréli a fel nem használt biztonsági kódokat. Add meg a jelszavad és egy aktuális kódot.',
  twofa_backup_remaining: '{n} fel nem használt biztonsági kód maradt',
  twofa_new_codes: 'Új biztonsági kódok',
  twofa_sms_unavailable: 'Az SMS-kódok még nem érhetők el.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "A hozzád rendelt Kjuup-feladatok a Todoist Kjuup projektjébe másolódnak. A Todoistben végzett módosítások nem másolódnak vissza.",
  todoist_connect: "Todoist csatlakoztatása",
  todoist_connected: "Todoist csatlakoztatva",
  todoist_connect_failed: "A Todoist csatlakoztatása sikertelen",
  todoist_disconnect: "Leválasztás",
  todoist_disconnected: "Todoist leválasztva",
  todoist_disconnect_confirm: "Leválasztod a Todoistot? A már létrehozott feladatok megmaradnak. A szinkronizálás leáll.",
  todoist_sync_now: "Szinkronizálás most",
  todoist_syncing: "Szinkronizálás…",
  todoist_sync_done: "Szinkronizálás kész",
  todoist_sync_failed: "A szinkronizálás sikertelen",
  todoist_auth_error: "A folytatáshoz csatlakoztasd újra a Todoistot.",
  todoist_last_sync: "Utolsó szinkronizálás",
  todoist_not_connected: "A Todoist nincs csatlakoztatva",
  todoist_auth_url_failed: "A Todoist engedélyezési oldala nem nyílt meg.",
  recommend_text: "Csatlakozz a Kjuuphoz, hogy kapcsolatban maradj, és rendben tartsd a kommunikációdat. Hozd össze a csatornáidat, tartsd az üzeneteket a megfelelő projektekben, és kezdj minden reggelt egy összefoglalóval és a feladataiddal – mindez szinkronban a már használt alkalmazásaiddal. Kezdd el ingyen:",
  pro_auth_signin_title: 'Üdvözöljük újra',
  pro_auth_signin_sub: 'Jelentkezzen be munkahelyi e-mail-címével.',
  pro_auth_email_or_username: 'E-mail vagy felhasználónév',
  pro_auth_email_placeholder: 'nev@ceg.hu',
  pro_auth_forgot_password: 'Elfelejtette jelszavát?',
  pro_auth_create_account: 'Fiók létrehozása',
  pro_auth_show_password: 'Jelszó megjelenítése',
  pro_auth_hide_password: 'Jelszó elrejtése',
  pro_auth_register_sub: 'Linket küldünk e-mail-címe megerősítéséhez.',
  pro_auth_register_plus_sub: 'Válasszon felhasználónevet és jelszót. Ezután állítsa be a biztonsági PIN-kódját.',
  pro_auth_check_credentials: 'Ellenőrizze e-mail-címét és jelszavát',
  pro_news_export_pdf: 'Exportálás PDF-ként',
  pro_news_pdf_failed: 'A PDF-et nem sikerült létrehozni.',
  pro_news_pdf_attachments: 'Mellékletek',
  pro_news_pdf_video: 'Videó',
  pro_auth_forgot_sub: 'Adja meg e-mail-címét, és linket küldünk a jelszó visszaállításához.',
  pro_auth_send_link: 'Visszaállítási link küldése',
  pro_auth_plus_reset: 'Visszaállítás PIN-kóddal',
  pro_auth_show_pin: 'PIN megjelenítése',
  pro_auth_hide_pin: 'PIN elrejtése',
  v2_auth_plus_only: 'Csak Kjuup+',
  room_action_media: "Fájlok",
  room_tab_overview: "Áttekintés",
  room_tab_history: "Előzmények",
  chat_info_media: "Fájlok",
  messages: "üzenetek",
  pro_todo_project_required: "Válassz egy projektet",
  pro_todo_choose_project: "Melyik projekthez tartozik ez a feladat?",
  cockpit_report_delete_confirm: "Törli ezt a napi jelentést?",
  cockpit_report_deleted: "Napi jelentés törölve",
  cockpit_tab_company: "Cég",
  cockpit_bookmarked_priorities: "Megjelölt feladatok",
  cockpit_load_error: "A cockpit nem tölthető be.",
  cockpit_retry: "Próbálja újra",
  cockpit_yesterday: "Tegnap",
  cockpit_greeting_morning: "Jó reggelt",
  cockpit_greeting_day: "Jó napot",
  cockpit_greeting_evening: "Jó estét",
  cockpit_assistant_q_open: "Mi van ma nyitva?",
  cockpit_assistant_q_summarize: "Foglalja össze a(z) {{room}} csevegést",
  cockpit_assistant_q_overdue: "Mely feladatok késnek?",
  cockpit_assistant_new: "{{n}} új",
  cockpit_assistant_important: "{{n}} fontos",
  cockpit_assistant_title: "Kjuup asszisztens",
  cockpit_assistant_hint: "Koppintson és kérdezzen",
  room_overview_priority_no_detail: "A jelentés nem közöl további részleteket erről a prioritásról.",
  room_overview_priority_from: "Forrás: {{name}}",
  room_overview_priority_open_task: "Feladat megnyitása",
  cockpit_priority_position: "{{index}} / {{total}} prioritás",
  room_overview_today_title: "Ma fontos",
  room_overview_all_tasks: "Összes",
  room_overview_tasks_empty: "Nincsenek nyitott határidők vagy feladatok",
  room_overview_appointments_empty: "Nincsenek közelgő időpontok",
  room_overview_no_priorities: "Nincs nyitott prioritás a legutóbbi jelentésben.",
  cockpit_report_top5: "Top 5 prioritás",
  cockpit_report_todo_created: "Feladat létrehozva",
  cockpit_report_source_missing: "A forrásüzenet nem található.",
  delete_bookmarked_priority_confirm: "Biztosan törli ezt a megjelölt feladatot?",
  cockpit_report_create_todo: "Feladat létrehozása",
  cockpit_priorities_deleting: "Törlés …",
  cockpit_priorities_select: "Több törlése",
  cockpit_report_none: "Nincs bejegyzés.",
  cockpit_priorities_delete_confirm: "Biztosan törli a(z) {count} megjelölt feladatot?",
  cockpit_priorities_delete_failed: "{count} feladat törlése nem sikerült",
  cockpit_priorities_deleted: "{count} feladat törölve",
  cockpit_priorities_selected: "{count} kiválasztva",
  cockpit_channel_connected: "Csatlakoztatva",
  cockpit_channel_not_connected: "Nincs csatlakoztatva",
  cockpit_channel_connect: "Csatlakoztatás",
  cockpit_channel_chat: "Kjuup csevegés",
  cockpit_channel_active: "Aktív",
  cockpit_channel_hidden: "Rejtett",
  cockpit_channel_enable: "Engedélyezés",
  cockpit_channel_email: "E-mail",
  cockpit_channel_check: "Kapcsolat ellenőrzése",
  cockpit_channel_fix: "Ellenőrzés",
  cockpit_channel_forward: "Továbbítási cím",
  cockpit_channel_not_set_up: "Nincs beállítva",
  cockpit_channel_set_up: "Beállítás",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "A kapcsolat megszakadt",
  cockpit_channel_importing: "Importálás folyamatban",
  cockpit_channel_removing: "Leválasztás",
  cockpit_channel_reconnect: "Újracsatlakoztatás",
  cockpit_channels_title: "Csatornák",
  cockpit_company_role_super_admin: "Cégadminisztrátor",
  cockpit_company_role_dept_admin: "Részlegadminisztrátor",
  cockpit_company_role_member: "Munkatárs",
  cockpit_company_none: "Nem található Kjuup+ cég",
  cockpit_company_eyebrow: "Cég",
  cockpit_company_inactive: "inaktív",
  cockpit_company_settings: "Cégbeállítások",
  cockpit_company_employees: "Munkatársak",
  cockpit_company_internal_rooms: "Belső projektek",
  cockpit_report_all_projects: "Összes projekt",
  cockpit_report_progress_emails: "E-mailek elemzése",
  cockpit_report_progress_chats: "Csevegőüzenetek elemzése",
  cockpit_report_progress_documents: "Mellékletek és dokumentumok elemzése",
  cockpit_report_progress_tasks: "Feladatok elemzése",
  cockpit_report_progress_summarizing: "Tartalom elemzése",
  cockpit_report_progress_reading: "Már elemzett tartalom újrafelhasználása",
  cockpit_report_progress_collecting: "E-mailek, csevegések és feladatok gyűjtése a projektjeiből",
  cockpit_report_progress_priorities: "Prioritások, határidők és döntések összeállítása",
  cockpit_report_progress_queued: "Jelentés előkészítése",
  cockpit_report_creating_title: "A napi jelentés készül",
  cockpit_report_progress_count_one: "1 elem elemezve",
  cockpit_report_progress_count_many: "{{count}} elem elemezve",
  cockpit_report_progress_hint: "Ez általában egy-két percet vesz igénybe – közben tovább használhatja a cockpitet.",
  cockpit_report_time_hint: "A napi jelentés minden nap {{hour}}:00-kor készül az öt legaktívabb projektről.",
  room_overview_priorities_title: "Aktuális állapot és prioritások",
  room_overview_as_of: "Állapot: {{time}}",
  cockpit_report_delete: "Napi jelentés törlése",
  email_tag_daily_briefing: "Napi jelentés",
  cockpit_report_unread: "Új",
  cockpit_report_clear_project: "Összes projekt megjelenítése",
  cockpit_filter_project: "Projekt",
  cockpit_filter_all_projects: "Összes projekt",
  cockpit_report_recreate: "Napi jelentés újralétrehozása",
  cockpit_report_hide_previous: "Korábbi napi jelentések elrejtése",
  cockpit_report_show_previous: "Korábbi napi jelentések megjelenítése",
  cockpit_report_room_empty: "Ehhez a projekthez még nincs napi jelentés",
  cockpit_report_empty: "Még nincs napi jelentés",
  cockpit_report_room_empty_hint: "Napi jelentés létrehozása csak ehhez a projekthez.",
  cockpit_report_needs_mailbox: "Csatlakoztasson egy e-mail-fiókot, hogy a Kjuup automatikus feladatokkal ellátott napi jelentést készíthessen.",
  cockpit_report_create: "Napi jelentés létrehozása",
  cockpit_email_connect: "E-mail csatlakoztatása",
  cockpit_email_none_title: "Még nincs e-mail-fiók csatlakoztatva",
  cockpit_email_none_reports: "Csatlakoztassa postafiókját, hogy a Kjuup a beérkező e-maileket a projektjeihez rendelje, és belőlük feladatokat tartalmazó napi jelentéseket készítsen.",
  cockpit_email_none_client: "Csatlakoztassa a Gmailt, az Outlookot vagy az IMAP-fiókot, hogy az e-maileket közvetlenül a Kjuup.io-ban olvassa, rendelje hozzá és válaszolja meg.",
  cockpit_email_reports_title: "Eddigi e-mail-kliens",
  cockpit_email_reports_text: "Nincs postafiók a Kjuup.io-ban · {{rooms}} projekt napi jelentéssel {{hour}}:00-kor · a beérkező e-mailek a projektjeihez lesznek rendelve.",
  cockpit_email_reports_rooms: "Projektek kezelése",
  cockpit_email_settings: "E-mail-beállítások",
  cockpit_email_error_title: "Kapcsolat ellenőrzése",
  cockpit_email_client_title: "Fogadás beállítva",
  cockpit_email_accounts_n: "{{n}} fiók csatlakoztatva",
  cockpit_email_last_sync: "utolsó szinkronizálás: {{when}}",
  cockpit_email_report_at: "Napi jelentés {{hour}}:00-kor",
  cockpit_email_open_inbox: "Postafiók megnyitása",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Csatlakoztatott e-mail-címek",
  email_folder_sent: "Elküldött elemek",
  email_no_subject: "(Nincs tárgy)",
  cockpit_email_detail_loading: "E-mail betöltése …",
  cockpit_email_detail_failed: "Az e-mail nem tölthető be.",
  cockpit_email_detail_empty: "Ennek az e-mailnek nincs szövege.",
  cockpit_personal_settings: "Személyes beállítások",
  cockpit_companies: "Cégek",
  cockpit_title: "Cockpit",
  cockpit_back: "Vissza az áttekintéshez",
  cockpit_day_overview: "A napja egy pillantásra",
  email_saved_to_project: "E-mail mentve a projektbe",
  email_classify_need_project: "Adjon meg egy projektnevet",
  cockpit_email_deleted: "E-mail törölve",
  cockpit_email_sent_empty: "Még nincsenek elküldött e-mailek.",
  cockpit_email_incoming_empty: "Még nincsenek beérkezett e-mailek.",
  cockpit_email_incoming_title: "E-mailek",
  cockpit_email_incoming_sub: "Rendelje a beérkező és elküldött e-maileket a projektjeihez. A hozzárendelést itt módosíthatja.",
  cockpit_email_incoming_unassigned_n: "{{n}} nincs hozzárendelve",
  cockpit_email_folder_inbox: "Beérkezett",
  cockpit_email_folder_sent: "Elküldött",
  cockpit_email_open: "E-mail megnyitása",
  cockpit_email_incoming_suggested: "Javaslat: {{room}}",
  cockpit_email_incoming_apply: "Alkalmaz",
  cockpit_email_incoming_adjust: "Hozzárendelés módosítása",
  cockpit_email_incoming_saving: "Mentés …",
  cockpit_email_incoming_unassigned: "Nincs hozzárendelve",
  cockpit_email_incoming_show_less: "Kevesebb megjelenítése",
  cockpit_email_incoming_show_all: "Mind a(z) {{n}} megjelenítése",
  cockpit_io_settings: "Kjuup.io beállítások",
  cockpit_io_settings_sub: "Csomag és helyek, munkatársak hozzárendelése, számlázás és számlák.",
  products_coming_soon: "Hamarosan elérhető",
  cockpit_upsell_io_title: "Az irodája, amely együtt gondolkodik",
  cockpit_upsell_io_text: "Csatlakoztassa e-mail-fiókjait a Kjuuphoz. Az e-mailek, mellékletek és üzenetek automatikusan a megfelelő projektbe kerülnek mentésre, és igény szerint a saját szerverén is tárolhatók. Minden nap összefoglalót kap az összes projektről az összes tartalom legfontosabb pontjaival, feladatai pedig szinkronizálódnak a naptárával vagy a teendőalkalmazásával.",
  cockpit_upsell_io_soon_title: "Még nem foglalható",
  cockpit_upsell_io_soon_text: "A Kjuup.io hamarosan indul. Kérjen most információt – értesítjük, amint megrendelheti a Kjuup.io-t.",
  cockpit_upsell_io_planned_price: "Tervezett ár",
  cockpit_upsell_io_cta_request: "Információkérés",
  kjuup_plus_abo_per_year: "/ év",
  kjuup_plus_abo_per_month: "/ hónap",
  kjuup_plus_abo_status_active: "Aktív",
  kjuup_plus_abo_status_requested: "Lemondás kérve",
  kjuup_plus_abo_status_past_due: "Fizetés esedékes",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Előfizetés",
  kjuup_plus_abo_title: "Kjuup+ csomag",
  kjuup_plus_abo_seats_free_one: "Még 1 szabad hely",
  kjuup_plus_abo_billing: "Fizetési mód",
  kjuup_plus_abo_yearly: "Évente",
  kjuup_plus_abo_monthly: "Havonta",
  kjuup_plus_abo_amount: "Összeg",
  kjuup_plus_abo_ends: "Lejár",
  kjuup_plus_abo_renews: "Következő megújítás",
  kjuup_plus_abo_next_invoice: "Következő számla",
  kjuup_plus_abo_intro: "Bevezetési ár",
  kjuup_plus_abo_pending_tier: "A következő megújítástól",
  kjuup_plus_abo_manual: "A Kjuup+ egyedi megállapodás alapján aktív az Ön cége számára.",
  kjuup_plus_abo_invoices: "Számlák",
  kjuup_plus_abo_invoice_paid: "Kifizetve",
  kjuup_plus_abo_invoice_view: "Megtekintés",
  kjuup_plus_abo_invoices_less: "Kevesebb megjelenítése",
  kjuup_plus_abo_member_hint: "A számlázást és a lemondást a cég adminisztrátorai kezelik.",
  kjuup_plus_abo_withdraw: "Kérelem visszavonása",
  kjuup_plus_abo_cancel_note: "Ok (nem kötelező)",
  kjuup_plus_abo_cancel_send: "Lemondás kérése",
  kjuup_plus_abo_cancel: "Előfizetés lemondása",
  cockpit_upsell_plus_f1: "Az összes munkatárs kommunikációs tevékenységének kezelése",
  cockpit_upsell_plus_f2: "Meghatározott felhasználói csoportok tájékoztatása a cégen belül",
  cockpit_upsell_plus_f3: "Belső csoportos csevegések mentése",
  cockpit_upsell_plus_when_yearly: "éves fizetés esetén",
  cockpit_upsell_plus_size_small: "1–50 munkatárs",
  cockpit_upsell_plus_size_large: "51–200 munkatárs",
  cockpit_upsell_plus_title: "Kjuup+ vállalatoknak",
  cockpit_upsell_plus_text: "Kezelje a munkatársakat, az írási jogosultságokat és a vállalati kommunikációt egy helyen. A belső csatornák a csapatánál maradnak, a külső csatornák összekötik a projektpartnerekkel, a meghatározott csoportokat pedig célzottan tájékoztathatja. A Kjuup+ mellett Kjuup.io-hozzáféréseket is rendelhet munkatársi csoportokhoz. A Kjuup+ és a Kjuup.io kombinálható.",
  cockpit_upsell_plus_size: "Cégméret",
  cockpit_upsell_plus_billing: "Fizetési mód",
  cockpit_upsell_plus_per_company: "/ cég · hónap, áfa nélkül",
  cockpit_upsell_plus_onboarding: "A bevezetési költségek a cégmérettől függnek",
  cockpit_upsell_plus_larger: "Nagyobb cégek árai kérésre",
  cockpit_upsell_plus_cta: "Kötelezettségmentes érdeklődés",
  cockpit_kpi_deadlines_tasks: "Határidők és feladatok",
  cockpit_kpi_appointments: "Időpontok",
  cockpit_room_admin: "Projekt- és csevegéskezelés",
  cockpit_room_admin_sub: "A cég összes projektje tagokkal, médiafájlokkal és csevegésekkel.",
  pro_todo_not_found: "Ez a feladat már nem érhető el.",
  cockpit_chip_overdue: "Késésben",
  cockpit_chip_today: "Ma",
  cockpit_calendar_week: "{{week}}. hét",
  cockpit_prev_week: "Előző hét",
  cockpit_next_week: "Következő hét",
  cockpit_chip_requested: "Kért",
  cockpit_todo_due: "Határidő: {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "{{name}} részéről",
  cockpit_todo_since: "{{when}} óta",
  cockpit_todo_no_date: "Nincs dátum",
  cockpit_todo_mark_done: "Megjelölés késznek",
  cockpit_my_tasks_title: "Saját feladataim",
  cockpit_today_tasks_group: "Mai feladatok",
  cockpit_assign_none: "Nincs senki hozzárendelve",
  no_project_found: "Nem található projekt",
  cockpit_row_more_actions: "További műveletek",
  needs_date: "Időpont hozzárendelése",
  cockpit_assign_proposal: "{{name}} felismerve – hozzárendeli?",
  cockpit_assign_proposal_confirm: "Hozzárendelés",
  cockpit_assign_proposal_dismiss: "Mellőzés",
  cockpit_priority_date: "Dátum",
  todo_calendar_add: "Hozzáadás a naptárhoz",
  todo_calendar_remove: "Eltávolítás a naptárból",
  cockpit_todo_change_project: "Projekt módosítása",
  cockpit_todo_set_date: "Dátum megadása",
  pro_todo_done_confirm: "Biztosan késznek jelöli ezt a feladatot?",
  cockpit_task_delete_failed: "A feladat nem törölhető.",
  cockpit_setup_title: "Beállítás befejezése",
  cockpit_setup_text: "Döntse el, hogy használni kíván-e csevegéseket, és hogy a Kjuup.io e-mail-kliensként működjön-e, vagy csak projektekkel és napi jelentésekkel.",
  cockpit_setup_cta: "Beállítás most",
  cockpit_group_tasks: "Határidők és feladatok",
  cockpit_group_appointments: "Időpontok",
  cockpit_report_no_activity: "Ebben a projektben az elmúlt 24 órában nem érkezett új üzenet vagy e-mail.",
  cockpit_report_room_unavailable: "Ez a projekt nem érhető el.",
  cockpit_report_create_failed: "A napi jelentés nem hozható létre.",
  cockpit_report_created: "Napi jelentés létrehozva",
  addon_enable_confirm: "Engedélyezi a bővítményt?",
  addon_enable: "Engedélyezés",
  addon_enabled: "Bővítmény engedélyezve",
  nav_email: "E-mail",
  nav_my_cockpit: "Cockpitem",
  nav_news: "Hírek",
  nav_recommend: "Ajánlás",
  pro_todo_status_done: "Kész",
  pro_todo_status_open: "Nyitott",
  v2_todo_remove: "Eltávolítás",
  pro_todo_search_people: "Személyek keresése",
  pro_todo_clear: "Törlés",
  pro_todo_assigned: "(hozzárendelve)",
  pro_todo_no_people: "Nem található személy",
  pro_todo_search_rooms: "Projektek keresése",
  pro_todo_no_rooms_match: "Nincs a(z) „{{q}}” keresésnek megfelelő projekt",
  pro_todo_no_rooms: "Nem található projekt",
  pro_todo_activity: "Aktivitás",
  pro_todo_show_less: "Kevesebb megjelenítése",
  pro_todo_show_all: "Mind megjelenítése ({{n}})",
  pro_todo_due: "Esedékes",
  pro_todo_room: "Projekt",
  pro_todo_select_room: "Projekt kiválasztása",
  pro_todo_status: "Állapot",
  pro_todo_more: "Több",
  pro_todo_edit_title: "Feladat szerkesztése",
  pro_todo_description: "Leírás",
  pro_todo_created_by: "Létrehozta",
  pro_todo_chat: "Csevegés",
  navigate_to_source: "Ugrás a forráshoz",
  todo_calendar_connect_title: "Nincs naptár csatlakoztatva",
  todo_calendar_connect_body_web: "Csatlakoztasson egy naptárat a naptárszinkron beállításaiban, hogy feladatokat adhasson hozzá.",
  todo_calendar_connect: "Csatlakoztatás",
  todo_calendar_removed: "Eltávolítva a naptárából",
  todo_calendar_added_later: "Hozzáadva. A naptár nem érhető el; a Kjuup később újra megpróbálja.",
  todo_calendar_added: "Hozzáadva a naptárához",
  todo_calendar_no_date: "Csak dátummal rendelkező feladat adható a naptárhoz.",
  todo_calendar_failed: "A naptár nem frissíthető. Kérjük, próbálja újra.",
  todo_calendar_date_title: "Még nincs dátum",
  todo_calendar_date_save: "Dátum megadása és hozzáadás",
  todo_calendar_date_body_web: "Ennek a megjelölt feladatnak még nincs dátuma. Adjon meg egyet, hogy a naptárhoz adhassa.",
  kjuup_io_setup_saved: "Beállítás mentve",
  kjuup_io_setup_step: "Lépés",
  kjuup_io_setup_chats_title: "Szeretne csevegéseket használni?",
  kjuup_io_setup_email_title: "Hol szeretné olvasni az e-mailjeit?",
  kjuup_io_setup_chats_sub: "A kollégákkal és projektpartnerekkel folytatott csevegések nem kötelezők. A cockpitben bármikor megjelenítheti vagy elrejtheti őket.",
  kjuup_io_setup_email_sub: "Itt csak azt választja ki, hogy a Kjuupban használ-e e-mail-klienst, vagy továbbra is a meglévő programját használja, például az Outlookot vagy mást. Később válthat.",
  kjuup_io_setup_chats_yes: "Igen, csevegések megjelenítése",
  kjuup_io_setup_chats_yes_text: "Az Üzenetek csevegéseket és e-maileket tartalmaz. A projektekhez csoportos csevegések tartoznak minden érintett számára.",
  kjuup_io_setup_chats_no: "Nem, csevegések nélkül dolgozom",
  kjuup_io_setup_chats_no_text: "A csevegések el vannak rejtve. Az „Üzenetek” „E-mail” lesz; a projektek, feladatok és napi jelentések megmaradnak.",
  kjuup_io_setup_email_client: "E-mail-kliens a Kjuupban",
  kjuup_io_setup_email_client_text: "E-mailek olvasása és megválaszolása közvetlenül a Kjuupban.",
  kjuup_io_setup_email_reports: "Eddigi e-mail-kliens",
  kjuup_io_setup_email_reports_text: "E-mailek olvasása és megválaszolása továbbra is a jelenlegi programban, például az Outlookban vagy másban.",
  kjuup_io_setup_skip: "Később",
  next: "Tovább",
  kjuup_io_setup_finish: "Beállítás befejezése",
  today_label: "ma",
  tomorrow_label: "holnap",
  cockpit_todo_overdue: "késésben",
  cockpit_report_management_fazit: "Vezetői összefoglaló",
  cockpit_todo_appointment: "Időpont",
  cockpit_todo_deadline: "Határidő",
  cockpit_todo_deadline_define: "Határidő megadása",
  pro_todo_status_acknowledged: "Megerősítve",
  pro_todo_responsible: "Felelős",
  pro_todo_notice_confirmed: "Megerősítve a csevegésben",
  pro_todo_notice_sent_at: "Üzenet elküldve",
  pro_todo_notice_again: "Üzenet újraküldése",
  pro_todo_notice_send: "Értesítés Kjuup-üzenettel",
  pro_todo_add_assignee: "Hozzáadás",
  pro_todo_edit: "Szerkesztés",
  pro_todo_change_room: "Projekt módosítása",
  pro_todo_due_on: "Esedékes ekkor:",
  pro_todo_edit_due: "Esedékesség szerkesztése",
  pro_todo_no_date: "Nincs dátum",
  pro_todo_edit_description: "Leírás szerkesztése",
  pro_todo_no_description: "Még nincs leírás",
  pro_todo_title_label: "Cím",
  pro_todo_title_placeholder: "Adja meg a címet...",
  pro_todo_task: "Feladat",
  pro_todo_what: "Mit kell tenni?",
  pro_todo_source_email: "E-mail",
  pro_todo_sources: "Források",
  previous: "Előző",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (legfeljebb {max} munkatárs)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (legfeljebb {max} munkatárs)",
  kjuup_plus_abo_status_ends: "Lejár: {date}",
  kjuup_plus_abo_seats_over: "Több mint {max} munkatárs – a Kjuup egyedi ajánlattal keresi meg Önt.",
  kjuup_plus_abo_seats_next: "Ha több munkatárs csatlakozik, a csomag automatikusan erre vált: {next} (időarányos elszámolással).",
  kjuup_plus_abo_seats_used: "{used} / {total} hely foglalt",
  kjuup_plus_abo_seats_free: "Még {count} szabad hely",
  kjuup_plus_abo_intro_until: "eddig: {date}",
  kjuup_plus_abo_invoice_open: "Nyitott · esedékes: {date}",
  kjuup_plus_abo_invoices_all: "Összes megjelenítése ({count})",
  kjuup_plus_abo_requested_hint: "Lemondás kérve: {date}. A Kjuup a futamidő végén ({end}) erősíti meg.",
  kjuup_plus_abo_cancel_hint: "A Kjuup megvizsgálja a kérését, és a futamidő végén ({end}) megerősíti a lemondást. Addig a Kjuup+ aktív marad.",
  kjuup_plus_abo_withdrawn: "Lemondási kérelem visszavonva",
  kjuup_plus_abo_requested: "Lemondás kérve",
  cockpit_upsell_plus_intro_hint: "az első {months} hónapban, utána {price}",
  cockpit_upsell_plus_badge: "{months} HÓNAPIG BEVEZETŐ ÁR",
  calendar_syncing: "Frissítés a naptárból…",
  calendar_sync_up_to_date: "A naptár naprakész",
  calendar_sync_failed: "A szinkronizálás sikertelen",
  delete_multiple_tasks_confirm: "Biztosan törölni szeretnél {count} ToDo-t?",
  todos_deleted_count: "{count} ToDo törölve",
  todos_deleted_partial: "{ok} ToDo törölve, {fail} sikertelen",
  todo_unknown: "Ismeretlen",
  todo_created_from_message: "Feladat létrehozva ebből az üzenetből",
  kjuup_io_todo_calendar_trial_ended_note: "Naptárszinkronizálás · Előfizetés",
  kjuup_io_todo_calendar_nudge: "Szinkronizálja ezt a ToDo-t a naptárával?",
  kjuup_io_todo_calendar_nudge_cta: "Kjuup.io aktiválása",
  todo_confirmed: "ToDo megerősítve",
  pro_todo_bulk_delete_title: "{{n}} feladat törlése?",
  pro_todo_previous_none_own: "A lejárt feladatokat mások osztották ki Önnek, és csak ők törölhetik őket.",
  pro_todo_previous_none: "Nincsenek lejárt feladatok",
  pro_todo_previous_title: "{{n}} lejárt feladat törlése?",
  pro_todo_previous_text: "A korábbi napokról maradt összes nyitott feladata törlődik.",
  pro_todo_previous_skipped: "{{n}} mások által kiosztott feladat megmarad.",
  unassign_task_confirm: "Szeretné visszavonni a kiosztását ehhez a feladathoz?",
  unassign_label: "Visszavonás",
  pro_todo_delete_title: "Feladat törlése",
  pro_todo_today: "Ma",
  pro_todo_yesterday: "Tegnap",
  pro_todo_since_yesterday: "Tegnap óta",
  pro_todo_mark_open: "Megjelölés nyitottként",
  verify_completion: "Ellenőrzés",
  new_label: "Új",
  bookmarked_no_mylist: "Könyvjelzőzött feladatok nem adhatók hozzá a Saját listához",
  delete_only_own: "Csak az Ön által létrehozott feladatokat törölheti",
  todo_clear_all: "Összes törlése",
  pro_todo_of_completed: "{{done}} / {{total}} kész",
  pro_todo_pick_date: "Válasszon dátumot",
  pro_todo_show_day: "Nap megjelenítése",
  todo_adjust_list: "Lista módosítása",
  pro_todo_section_upcoming: "Közelgő",
  pro_todo_section_done: "Kész",
  pro_todo_room_empty_today: "Ma nincs feladat ebben a projektben",
  pro_todo_room_empty_day: "Ezen a napon nincs feladat ebben a projektben",
  pro_todo_delete_previous: "Összes törlése",
  todo_my_list_empty: "A napod üres",
  todo_my_list_empty_hint: "Kattintson a „Lista módosítása” gombra a feladatok hozzáadásához",
  pro_todo_empty_title: "Itt nincs semmi",
  pro_todo_empty_hint: "Nincs ennek a nézetnek megfelelő feladat.",
  pro_todo_selected: "{{n}} kiválasztva",
  delete_selected_count: "Törlés ({count})",
  pro_todo_adjust_done: "Kész",
  pro_todo_deleting: "Törlés...",
  pro_todo_reopen: "Feladat újranyitása",
  pro_todo_step_done: "Elvégezve",
  move_back_in_progress: "Vissza Folyamatban állapotba",
  pro_todo_mark_not_started: "Megjelölés nem megkezdettként",
  back_into_in_progress: "Vissza folyamatba",
  pro_todo_mark_in_progress: "Megjelölés folyamatban lévőként",
  unassign_todo: "ToDo kiosztás visszavonása",
  pro_todo_open_room: "Projekt megnyitása",
  pro_todo_new_task: "Új feladat",
  select_user_back_to_in_progress: "Válassza ki a felhasználót, akit vissza szeretne állítani Folyamatban állapotba",
  cockpit_email_accounts_n_many: "{{n}} fiók csatlakoztatva",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup-névjegyek",
  combined_tab_teams: "Teams-névjegyek",
  combined_bridge_failed: "A Teams-másolatot nem sikerült létrehozni.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup- és Teams-névjegyek: új csoport jön létre, amely a Microsoft Teamsben is megjelenik.",
  teams_new_chat_title: "Új Teams-csevegés",
  teams_new_chat_topic: "Csoportnév (nem kötelező)",
  teams_new_chat_start: "Csevegés indítása",
  teams_new_chat_creating: "Csevegés létrehozása…",
  teams_new_chat_forbidden: "A Microsoft Teams nem engedélyezi ezt a csevegést (pl. a szervezeteden kívüli személy vagy az IT egy szabálya).",
  teams_new_chat_too_many: "Túl sok személy egy csevegéshez.",
  teams_new_chat_type_hint: "Írj be egy nevet a szervezeteden belüli kereséshez.",
  teams_new_chat_directory_forbidden: "A szervezeted nem engedélyezi a címtárban való keresést. Csak a Teams-csevegéseidből származó személyek láthatók.",
  teams_new_chat_account: "Fiók",
};
